import React from 'react';
import { cn } from '@/lib/utils';

export interface TileGridProps {
  /** Grid children (typically Tile components) */
  children: React.ReactNode;
  
  /** Number of columns */
  columns?: 1 | 2 | 3 | 4 | 5 | 6;
  
  /** Gap between tiles */
  gap?: 'sm' | 'md' | 'lg' | 'xl';
  
  /** Custom CSS classes */
  className?: string;
  
  /** Enable auto-fit responsive columns */
  autoFit?: boolean;
  
  /** Minimum column width for auto-fit (in px) */
  minColumnWidth?: number;
}

const TileGrid: React.FC<TileGridProps> = ({
  children,
  columns = 3,
  gap = 'md',
  className,
  autoFit = false,
  minColumnWidth = 300,
}) => {
  const gapClasses = {
    sm: 'gap-4',
    md: 'gap-6',
    lg: 'gap-8',
    xl: 'gap-10',
  };
  
  const columnClasses = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4',
    5: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5',
    6: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6',
  };
  
  const gridStyle = autoFit ? {
    display: 'grid',
    gridTemplateColumns: `repeat(auto-fit, minmax(${minColumnWidth}px, 1fr))`,
  } : {};
  
  return (
    <div
      className={cn(
        'grid',
        'items-stretch',
        !autoFit && columnClasses[columns],
        gapClasses[gap],
        className
      )}
      style={{
        ...gridStyle,
        gridAutoRows: '1fr',
      }}
    >
      {children}
    </div>
  );
};

export default TileGrid;

